module.exports = __webpack_public_path__ + "img/carousel1.330e7ff8.jpg";